
  export default {
    mounted() {
      window.addEventListener('scroll', this.scroll)
    },
    destroyed() {
      window.removeEventListener('scroll', this.scroll)
    },
    methods: {
      scroll() {
        // if (process.browser) {
        //   const nav = document.querySelector('.about-nav')
        //   if (window.pageYOffset >= 167) {
        //     nav.style.top = '0px'
        //     nav.style.position = 'fixed'
        //     nav.classList.remove('shadow')
        //   } else {
        //     nav.style.top = 'unset'
        //     nav.style.position = 'absolute'
        //     nav.classList.add('shadow')
        //   }
        // }
      }
    }
  }
